import script from "./EditorTextoInput.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorTextoInput.vue?vue&type=script&setup=true&lang=js"

import "./EditorTextoInput.vue?vue&type=style&index=0&id=3c032a62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c032a62"]])

export default __exports__